<template>
  <div class="min-h-screen bg-white">
    <slot />
  </div>
  <Footer condensed />
</template>
